// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__i8Ci4","iconWrapper":"SideBar_iconWrapper__oSrKX","iconText":"SideBar_iconText__F3fnC","activeLink":"SideBar_activeLink__J0Fiz"};